import requests from "./AxiosClient";
import { callPath } from "./endpoint";

const SaleService = {
   // Get order list
   getAll: async () => {
      const jsonData = {
         model: "sale.order",
         method: "web_search_read",
         kwargs: {
            domain: [["state", "not in", ["draft", "sent", "cancel"]]],
            specification: {
               name: {},
               id: {},
               state: {},
               date_order: {},
               user_id: {
                  fields: {
                     name: {},
                  },
               },
               team_id: {
                  fields: {
                     name: {},
                  },
               },
               company_id: {
                  fields: {
                     name: {},
                     phone: {},
                     email: {},
                  },
               },
               partner_id: {
                  fields: {
                     name: {},
                     phone: {},
                     email: {},
                     contact_address: {},
                  },
               },
               tax_totals: {
                  fields: {
                     amount_untaxed: {},
                     amount_tax: {},
                     name: {},
                  },
               },
               amount_tax: {},
               invoice_status: {},
               order_line: {
                  fields: {
                     id: {},
                     order_id: {},
                     name: {},
                     price_tax: {},
                     price_total: {},
                     discount: {},
                     price_subtotal: {},
                     product_uom_qty: {},
                  },
               },
            },
         },
      };
      return requests.post(callPath, jsonData, {
         headers: {
            "Content-Type": "application/json",
         },
      });
   },

   // Get order by id
   getById: async (id) => {
      const jsonData = {
         model: "sale.order",
         method: "web_search_read",
         with_context: {
            lang: "en_US",
         },
         kwargs: {
            domain: [["id", "=", id]],
            specification: {
               name: {},
               id: {},
               state: {},
               date_order: {},
               user_id: {
                  fields: {
                     name: {},
                  },
               },
               margin: {},
               margin_percent: {},
               team_id: {
                  fields: {
                     name: {},
                  },
               },
               company_id: {
                  fields: {
                     name: {},
                     phone: {},
                     email: {},
                  },
               },
               partner_id: {
                  fields: {
                     name: {},
                     phone: {},
                     email: {},
                     contact_address: {},
                  },
               },
               tax_totals: {
                  fields: {
                     amount_untaxed: {},
                     amount_tax: {},
                     name: {},
                     groups_by_subtotal: {
                        fields: {
                           "Untaxed Amount": {},
                        },
                     },
                  },
               },
               amount_tax: {},
               invoice_status: {},
               order_line: {
                  fields: {
                     id: {},
                     order_id: {},
                     name: {},
                     price_total: {},
                     discount: {},
                     price_subtotal: {},
                     product_uom_qty: {},
                     qty_delivered: {},
                     product_id: {
                        fields: {
                           image_256: {},
                        },
                     },
                     price_unit: {},
                     tax_id: {
                        fields: {
                           display_name: {},
                        },
                     },
                     product_uom: {
                        fields: {
                           display_name: {},
                        },
                     },
                  },
               },
            },
         },
      };

      return requests.post(callPath, jsonData, {
         headers: {
            "Content-Type": "application/json",
         },
      });
   },

   // Get customer
   getNameCustomer: async (context, term) => {
      const jsonData = {
         model: "res.partner",
         method: "name_search",
         with_context: {
            lang: "en_US",
            allowed_company_ids: context,
         },
         kwargs: {
            name: term,
            operator: "ilike",
            args: [["company_id", "in", [false, ...context]]],
            limit: 8,
         },
      };

      return requests.post(callPath, jsonData, {
         headers: {
            "Content-Type": "application/json",
         },
      });
   },

   // Get product name
   getNameProduct: async (term) => {
      const jsonData = {
         model: "product.template",
         method: "name_search",
         kwargs: {
            name: term,
            operator: "ilike",
            args: [["sale_ok", "=", true]],
            limit: 8,
         },
      };

      return requests.post(callPath, jsonData, {
         headers: {
            "Content-Type": "application/json",
         },
      });
   },

   // check variant product
   getVariantProduct: async (ids) => {
      const jsonData = {
         model: "product.template",
         method: "web_read",
         ids: ids,
         kwargs: {
            specification: {
               product_variant_count: {},
               service_type: {},
               visible_expense_policy: {},
               is_kits: {},
               is_product_variant: {},
               attribute_line_ids: {
                  fields: {
                     value_count: {},
                     sequence: {},
                     attribute_id: {
                        fields: {
                           display_type: {},
                           display_name: {},
                        },
                     },
                     value_ids: {
                        fields: {
                           display_name: {},
                           color: {},
                           html_color: {},
                        },
                        context: {
                           show_attribute: false,
                        },
                     },
                  },
                  limit: 40,
                  order: "sequence ASC, id ASC",
               },
               type: {},
               company_id: {
                  fields: {
                     display_name: {},
                  },
               },
               fiscal_country_codes: {},
               product_document_count: {},
               tracking: {},
               show_on_hand_qty_status_button: {},
               show_forecasted_qty_status_button: {},
               qty_available: {},
               uom_name: {},
               virtual_available: {},
               nbr_moves_in: {},
               nbr_moves_out: {},
               reordering_min_qty: {},
               reordering_max_qty: {},
               nbr_reordering_rules: {},
               bom_count: {},
               used_in_bom_count: {},
               mrp_product_qty: {},
               purchased_product_qty: {},
               sales_count: {},
               id: {},
               image_256: {},
               write_date: {},
               priority: {},
               name: {},
               sale_ok: {},
               purchase_ok: {},
               active: {},
               detailed_type: {},
               invoice_policy: {},
               expense_policy: {},
               product_tooltip: {},
               uom_id: {
                  fields: {
                     display_name: {},
                  },
               },
               uom_po_id: {
                  fields: {
                     display_name: {},
                  },
               },
               list_price: {},
               tax_string: {},
               taxes_id: {
                  fields: {
                     display_name: {},
                  },
                  context: {
                     default_type_tax_use: "sale",
                     search_default_sale: 1,
                  },
               },
               standard_price: {},
               cost_method: {},
               valuation: {},
               categ_id: {
                  fields: {
                     display_name: {},
                  },
               },
               default_code: {},
               valid_product_template_attribute_line_ids: {},
               barcode: {},
               brand_id: {
                  fields: {
                     display_name: {},
                  },
               },
               product_tag_ids: {
                  fields: {
                     display_name: {},
                  },
               },
               currency_id: {
                  fields: {},
               },
               cost_currency_id: {
                  fields: {},
               },
               product_variant_id: {
                  fields: {},
               },
               product_properties: {},
               description: {},
               combo_ids: {
                  fields: {
                     sequence: {},
                     name: {},
                     base_price: {},
                     num_of_products: {},
                  },
                  limit: 40,
                  order: "sequence ASC, id ASC",
               },
               optional_product_ids: {
                  fields: {
                     display_name: {},
                     color: {},
                  },
               },
               description_self_order: {},
               available_in_pos: {},
               to_weight: {},
               pos_categ_ids: {
                  fields: {
                     display_name: {},
                  },
               },
               self_order_available: {},
               description_sale: {},
               sale_line_warn: {},
               sale_line_warn_msg: {},
               seller_ids: {
                  fields: {
                     sequence: {},
                     partner_id: {
                        fields: {
                           display_name: {},
                        },
                     },
                     product_id: {
                        fields: {
                           display_name: {},
                        },
                     },
                     product_tmpl_id: {
                        fields: {
                           display_name: {},
                        },
                     },
                     product_name: {},
                     product_code: {},
                     date_start: {},
                     date_end: {},
                     company_id: {
                        fields: {
                           display_name: {},
                        },
                     },
                     min_qty: {},
                     product_uom: {
                        fields: {
                           display_name: {},
                        },
                     },
                     price: {},
                     discount: {},
                     delay: {},
                  },
                  limit: 40,
                  order: "sequence ASC, id ASC",
                  context: {
                     product_template_invisible_variant: true,
                     tree_view_ref: "purchase.product_supplierinfo_tree_view2",
                  },
               },
               variant_seller_ids: {
                  fields: {
                     sequence: {},
                     partner_id: {
                        fields: {
                           display_name: {},
                        },
                     },
                     product_id: {
                        fields: {
                           display_name: {},
                        },
                     },
                     product_tmpl_id: {
                        fields: {
                           display_name: {},
                        },
                     },
                     product_name: {},
                     product_code: {},
                     date_start: {},
                     date_end: {},
                     company_id: {
                        fields: {
                           display_name: {},
                        },
                     },
                     min_qty: {},
                     product_uom: {
                        fields: {
                           display_name: {},
                        },
                     },
                     price: {},
                     discount: {},
                     delay: {},
                  },
                  limit: 40,
                  order: "sequence ASC, id ASC",
                  context: {
                     model: "product.template",
                     tree_view_ref: "purchase.product_supplierinfo_tree_view2",
                  },
               },
               service_to_purchase: {},
               supplier_taxes_id: {
                  fields: {
                     display_name: {},
                  },
                  context: {
                     default_type_tax_use: "purchase",
                  },
               },
               purchase_method: {},
               description_purchase: {},
               has_available_route_ids: {},
               route_ids: {
                  fields: {},
               },
               route_from_categ_ids: {
                  fields: {
                     display_name: {},
                  },
               },
               responsible_id: {
                  fields: {
                     display_name: {},
                  },
               },
               weight: {},
               weight_uom_name: {},
               volume: {},
               volume_uom_name: {},
               sale_delay: {},
               property_stock_production: {
                  fields: {
                     display_name: {},
                  },
               },
               property_stock_inventory: {
                  fields: {
                     display_name: {},
                  },
               },
               description_pickingin: {},
               description_pickingout: {},
               description_picking: {},
               display_name: {},
            },
         },
      };

      return requests.post(callPath, jsonData, {
         headers: {
            "Content-Type": "application/json",
         },
      });
   },

   // 
   getAllAsset: async () => {
      const jsonData = {
         model: "account.asset",
         method: "web_search_read",
         kwargs: {
            domain: [],
            specification: {
               display_name: {},
               original_value: {},
               book_value: {},
               company_id: {
                  fields: {
                     display_name: {},
                     logo: {}
                  },
               }
            }
         },
      };
      return requests.post(callPath, jsonData, {
         headers: {
            "Content-Type": "application/json",
         },
      });
   },
};

export default SaleService;
